/**
 * Which of an agent's two action lists an action belongs to. The API has no trigger field - the
 * list an action sits in is what says when it runs - so this only exists to drive the panel.
 */
export enum CurationOutcomeEnum {
    /** positiveActions - run when a mention matches the agent's criteria */
    matching = 'MATCHING',
    /** negativeActions - run when it does not */
    nonMatching = 'NON_MATCHING'
}

export const curationOutcomes: CurationOutcomeEnum[] = [
    CurationOutcomeEnum.matching,
    CurationOutcomeEnum.nonMatching
];

export const curationOutcomeLabels: Record<CurationOutcomeEnum, string> = {
    [CurationOutcomeEnum.matching]: 'AutomationAgents.panel.actions.outcome.matching',
    [CurationOutcomeEnum.nonMatching]: 'AutomationAgents.panel.actions.outcome.nonMatching'
};
